import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { renderChildren, text } from "../helpers";

var root = $.from_html(`<div></div>`);

export default function Grid($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	function colValue(value, fallback = 1) {
		const n = Number(value ?? fallback);

		return Number.isFinite(n) ? String(n) : String(fallback);
	}

	var div = root();
	let styles;

	$.action(div, ($$node, $$action_arg) => renderChildren?.($$node, $$action_arg), () => $$props.ctx);

	$.template_effect(
		($0, $1, $2, $3, $4, $5, $6, $7) => {
			$.set_class(div, 1, $0);
			$.set_attribute(div, 'id', $1);
			$.set_attribute(div, 'data-cols', $2);
			$.set_attribute(div, 'data-cols-sm', $3);
			$.set_attribute(div, 'data-cols-md', $4);
			$.set_attribute(div, 'data-cols-lg', $5);
			$.set_attribute(div, 'data-cols-xl', $6);
			styles = $.set_style(div, '', styles, $7);
		},
		[
			() => `slex-grid${$.get(p).class ? ` ${text($.get(p).class)}` : ""}`,
			() => $.get(p).id ? text($.get(p).id) : undefined,
			() => colValue($.get(p).columns),
			() => $.get(p).smColumns === undefined
				? undefined
				: colValue($.get(p).smColumns, Number($.get(p).columns ?? 1)),
			() => colValue($.get(p).mdColumns, Number($.get(p).columns ?? 1)),
			() => $.get(p).lgColumns === undefined
				? undefined
				: colValue($.get(p).lgColumns, Number($.get(p).mdColumns ?? $.get(p).columns ?? 1)),

			() => $.get(p).xlColumns === undefined
				? undefined
				: colValue($.get(p).xlColumns, Number($.get(p).lgColumns ?? $.get(p).mdColumns ?? $.get(p).columns ?? 1)),
			() => ({ gap: text($.get(p).gap) })
		]
	);

	$.append($$anchor, div);
	$.pop();
}